"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyGlobalRateLimitError = exports.GlobalRateLimit = exports.defaultGlobalRateLimitText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var styled_1 = require("./styled");
var error_icon_1 = require("../../../error-icon");
var hooks_1 = require("../../../../hooks");
var count_down_1 = require("../count-down");
exports.defaultGlobalRateLimitText = {
    sorry: "We\u2019re sorry",
    message: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Our site is currently experiencing heavy traffic.", (0, jsx_runtime_1.jsx)("b", { children: " Please wait in line for a few seconds " }), "while we work to get everything up and running smoothly."] })),
    thankYou: "Thank you for your patience.",
};
var GlobalRateLimit = function (_a) {
    var dialogProps = _a.dialogProps, retryAfter = _a.retryAfter, _b = _a.text, text = _b === void 0 ? exports.defaultGlobalRateLimitText : _b;
    var theme = (0, hooks_1.useGracefulTheme)();
    var retriesLeft = (0, hooks_1.useGraceful)().ctx.retriesLeft;
    var typographyCommonProps = {
        fontSize: 16,
        fontWeight: '400',
        sx: {
            width: '90%',
            margin: '0 auto',
            textAlign: 'center',
            color: theme.text,
        },
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Dialog, __assign({}, __assign(__assign({}, dialogProps), { PaperComponent: material_1.Paper, maxWidth: 'sm', PaperProps: {
            sx: { p: 3 },
        } }), { children: (0, jsx_runtime_1.jsxs)(styled_1.GlobalRateLimitStyled, { children: [(0, jsx_runtime_1.jsx)(error_icon_1.ErrorIcon, { sx: { width: 450, height: 350 } }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, {
                    fontSize: 36,
                    fontWeight: '700',
                }, { children: text.sorry })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, typographyCommonProps, { children: text.message })), (0, jsx_runtime_1.jsx)(count_down_1.CountDown, { seconds: retryAfter, retriesLeft: retriesLeft }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, typographyCommonProps, { children: text.thankYou }))] }) })));
};
exports.GlobalRateLimit = GlobalRateLimit;
var ApplyGlobalRateLimitError = function (_a) {
    var children = _a.children;
    var _b = (0, hooks_1.useGraceful)().ctx, status = _b.status, responseBody = _b.responseBody, headers = _b.headers;
    var isGlobalRateLimited = (0, react_1.useMemo)(function () {
        if (status !== 429) {
            return false;
        }
        return ((responseBody === null || responseBody === void 0 ? void 0 : responseBody.global) === true ||
            (headers === null || headers === void 0 ? void 0 : headers['x-ratelimit-global']) === 'true');
    }, [headers, responseBody, status]);
    var retryAfter = (0, react_1.useMemo)(function () {
        if (!isGlobalRateLimited)
            return 0;
        var retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers['retry-after'];
        var retryAfterBody = responseBody === null || responseBody === void 0 ? void 0 : responseBody.retryAfter;
        return retryAfterBody || parseInt(retryAfterHeader) || 0;
    }, [headers, responseBody, isGlobalRateLimited]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.GlobalRateLimit, __assign({}, {
                dialogProps: {
                    open: isGlobalRateLimited,
                },
                retryAfter: retryAfter,
            })), !isGlobalRateLimited && children] }));
};
exports.ApplyGlobalRateLimitError = ApplyGlobalRateLimitError;
